const Admin = [
	{
		path: '/admin/notifications',
		name: 'notifications',
		component: () => import(/* webpackChunkName: "Admin" */ '@/pages/Admin/Notifications.vue'),
		meta: {
			title: 'Notifications | Admin',
			auth: true,
		},
	},
	{
		path: '/admin/paymentSwitch',
		name: 'paymentSwitch',
		component: () => import(/* webpackChunkName: "Admin" */ '@/pages/Admin/PaymentSwitch.vue'),
		meta: {
			title: 'PaymentSwitch | Admin',
			auth: true,
		},
	},
	{
		path: '/admin/liveChatSwitch',
		name: 'liveChatSwitch',
		component: () => import(/* webpackChunkName: "Admin" */ '@/pages/Admin/LiveChatSwitch.vue'),
		meta: {
			title: 'Live Chat | Admin',
			auth: true,
		},
	},
	{
		path: '/admin/riskResources',
		name: 'liveChatSwitch',
		component: () => import(/* webpackChunkName: "Admin" */ '@/pages/Admin/RiskResources.vue'),
		meta: {
			title: 'Risk Resources | Admin',
			auth: true,
		},
	},
];

export default Admin;
